<template>
  <div class="box-shadow" v-if="can_access('custodian','modify')">
  <form @submit.stop.prevent ref="form" class="col-md-12">
    <div class="row">
    <div class="form-group col-sm-8">
        <label class="active">Custodian Name</label>
        <vue-bootstrap-typeahead
            ref="custodian_name"
            :data="custodians"
            v-model="formInput.name"
            :serializer="custodianFormattedDisplay"
            placeholder="Type Custodian Name"
            @hit="setCustodianInfo"
            :minMatchingChars="0"
        />
    </div>
    <div class="form-group col-sm-4">
        <label>Status</label>
        <select name="type" class="form-control" v-model="formInput.status">
            <option selected value="1">Active</option>
            <option value="0">Inactive</option>
        </select>
    </div>
    </div>
    <div class="mt-4" style="display:flow-root">
	    <button class="btn btn-lg btn-info pull-right" @click="set_custodian" :disabled="btn_disabled">Submit</button>
    </div>
  </form>
  </div>
</template>
<script>
import $ from 'jquery';
import common from '@/assets/js/common.js';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import { mapActions } from 'vuex';
export default {
  name: "AddRemoveCustodian",
  mixins: [common],
  components: {
      VueBootstrapTypeahead
  },
  props: {},
  data(){
    return {
      custodians: [],
      btn_disabled: false,
      formInput: {
          name: '',
          status: 1,
      }
    }
  },
  created(){
    this.call_axios('get_custodians?with_disabled=1').then(res => {
        console.log(res)
        this.custodians = res.response.data;
    });
  },
  methods:{
    ...mapActions('layout', ['changeBodyLoading']),
    custodianFormattedDisplay(result){
        return result.name;
    },
    setCustodianInfo (group) {
      this.formInput.name = (typeof group == "object") ? group.name : group;
      this.formInput.status = (typeof group == "object") ? group.status : group;
    },
    set_custodian(){
        this.call_axios('set_custodian','post',this.formInput).then(res => {
            this.$emit('forceRerender', res.response);
        })
    }
  }
}
</script>